import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 18, viewBox: "0 0 25 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("rect", { width: 25, height: 2.25, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { width: 25, height: 2.25, y: 7.875, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { width: 25, height: 2.25, y: 15.75, rx: 1 })));
const ForwardRef = forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
